import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { runtimeCss as _runtimeCss, mergeProps as _mergeProps, cssRef as _cssRef, mergeComponentProps as _mergeComponentProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("star-rating__star-3cscd4", {
  position: "relative",
  lineHeight: 0,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  "& svg": {
    display: "block"
  }
});
const _staticStyles2 = _cssRef("star-rating__starfill-2zmdkc", {
  position: "absolute",
  top: 0,
  left: 0,
  overflow: "hidden",
  "& path": {
    fill: "#F7A427"
  }
});
const _staticStyles3 = _cssRef("star-rating__decorativefill-2dbcdf", {
  "& path": {
    fill: "#F7A427"
  }
});
import React from 'react';
import type { SerializedStyles } from "@terraindigital/static-styles-react";
export const STAR_FILL_COLOR = '#F7A427';
const STAR_EMPTY_COLOR = '#C7C7C7';

/* eslint-disable max-len */
const STAR_EMPTY_PATH = 'M13.76 8.20762L22 8.43262L15.465 13.4765L17.7986 21.4117L11.0002 16.7326L4.20187 21.4117L6.53531 13.4758L0 8.43263L8.2403 8.20762L11.0002 0.411743L13.76 8.20762ZM12.6415 9.75286L11.0002 5.1166L9.35885 9.75286L4.45914 9.88666L8.34527 12.8855L6.95757 17.605L11.0002 14.8226L15.0427 17.6049L13.6551 12.8864L17.5415 9.88667L12.6415 9.75286Z';
const STAR_FILL_PATH = 'M13.76 8.20762L22 8.43262L15.465 13.4765L17.7986 21.4117L11.0002 16.7326L4.20187 21.4117L6.53531 13.4758L0 8.43263L8.2403 8.20762L11.0002 0.411743L13.76 8.20762Z';
/* eslint-enable max-len */

type StarIconProps = {
  width: number;
  height: number;
  css?: SerializedStyles;
};
const StarEmptyIcon = ({
  width,
  height
}: StarIconProps): JSX.Element => <svg viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" width={width} height={height} aria-hidden>
        <path fillRule="evenodd" clipRule="evenodd" d={STAR_EMPTY_PATH} fill={STAR_EMPTY_COLOR} />
    </svg>;
const StarFillIcon = ({
  width,
  height,
  css: cssProp
}: StarIconProps): JSX.Element => <svg {..._mergeProps({
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  width: width,
  height: height,
  css: _runtimeCss(cssProp),
  "aria-hidden": true
})}>
        <path fillRule="evenodd" clipRule="evenodd" d={STAR_FILL_PATH} fill={STAR_FILL_COLOR} />
    </svg>;
export const starFillWidth = (rating: number, starIndex: number): string | null => {
  if (starIndex >= Math.ceil(rating)) {
    return null;
  }
  if (starIndex < Math.floor(rating)) {
    return '100%';
  }
  return `${Math.round(100 * (rating % 1))}%`;
};
const styles = {
  row: (gap: number) => _runtimeCss({
    display: 'flex',
    alignItems: 'center',
    gap: `${gap}px`
  }),
  star: _staticStyles,
  starFill: _staticStyles2,
  decorativeFill: _staticStyles3
};
export type StarRatingProps = {
  variant: 'rated' | 'decorative';
  rating?: number;
  size?: number;
  gap?: number;
  className?: string;
  css?: SerializedStyles;
};
export const StarRating = ({
  variant,
  rating = 0,
  size = 18,
  gap = 4,
  className,
  css: cssProp
}: StarRatingProps): JSX.Element => {
  if (variant === 'decorative') {
    return <div {..._mergeProps({
      css: [_runtimeCss(styles.row(gap)), cssProp],
      className: className,
      "aria-hidden": true
    })}>
                {[...Array(5).keys()].map(i => <StarFillIcon {..._mergeComponentProps({
        key: i,
        css: styles.decorativeFill,
        width: size,
        height: size
      })} />)}
            </div>;
  }
  const clampedRating = Math.max(0, Math.min(5, rating));
  return <div {..._mergeProps({
    css: [_runtimeCss(styles.row(gap)), cssProp],
    className: className
  })}>
            {[...Array(5).keys()].map(i => {
      const fillWidth = starFillWidth(clampedRating, i);
      return <div {..._mergeProps({
        css: styles.star,
        key: i
      })}>
                        <StarEmptyIcon width={size} height={size} />
                        {fillWidth && <div {..._mergeProps({
          css: styles.starFill,
          style: {
            width: fillWidth
          }
        })}>
                                <StarFillIcon width={size} height={size} />
                            </div>}
                    </div>;
    })}
        </div>;
};